
import React from 'react';
import _ from 'lodash';
import { WALLBOARD_FRAME_VH } from '../../../util/wallboardFrame';
import './Holder.scss';

class Holder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rightWidth: 'auto',
      rightHeight: 'auto',
      leftWidth: 'auto',
      leftHeight: 'auto'
    };

    this.holderSwitch = React.createRef();
    this.resizeHandler = this.resize.bind(this);
  }

  componentDidMount() {
    this.resize();
    this.subscribe();
  }

  componentDidUpdate() {
    this.resize();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribe() {
    window.addEventListener('resize', this.resizeHandler);
  }

  unsubscribe() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  resize() {
    if (this.holderSwitch.current) {
      // not getBoundingClientRect: on the TV wallboard the whole page is scaled to the screen
      const rect = { width: this.holderSwitch.current.offsetWidth, height: this.holderSwitch.current.offsetHeight };
      const rightHeight = rect.height;
      const gap = this.props.wallmode ? WALLBOARD_FRAME_VH : 0.01 * window.innerHeight;
      const rightWidth = rightHeight - 28 - gap;
      const leftHeight = rightHeight;
      const leftWidth = rect.width - rightWidth;
      if (
        !_.isEqual(
          {
            rightWidth: `${rightWidth.toFixed(0)}px`,
            rightHeight: `${rightHeight.toFixed(0)}px`,
            leftWidth: `${leftWidth.toFixed(0)}px`,
            leftHeight: `${leftHeight.toFixed(0)}px`
          },
          this.state
        )
      ) {
        this.setState({
          rightWidth: `${rightWidth.toFixed(0)}px`,
          rightHeight: `${rightHeight.toFixed(0)}px`,
          leftWidth: `${leftWidth.toFixed(0)}px`,
          leftHeight: `${leftHeight.toFixed(0)}px`
        });
      }
    }
  }

  render() {
    const { leftWidth, leftHeight, rightWidth, rightHeight } = this.state;
    return (
      <div ref={this.holderSwitch} className={ this.props.children[0] ? 'holder' : 'holder holder--single-child' }>
        {this.props.children[0] && (
        <div className="left" style={{ width: leftWidth }}>
          {this.props.children[0]}
        </div>)}
        <div className="right"style={{ width: this.props.children[0] ? rightWidth : '100%' }}>
          {this.props.children[1]}
        </div>
      </div>
    );
  }
}

export { Holder };
